import { atom, RecoilState } from 'recoil';
import { Project } from 'api/models';

type ProjectState = {
  projects: Project[];
  selectedProject?: Project | null;
};

export const projectState: RecoilState<ProjectState> = atom<ProjectState>({
  key: 'projectState',
  default: {
    projects: [],
  },
});
